import {
  GENERIC,
  INTRO_EMAIL,
  PROMO_CODE,
  SPECIAL_EMAIL,
  SPECIAL_URL,
} from "constants/perks";

export type PerkType =
  | "PROMO_CODE"
  | "SPECIAL_URL"
  | "INTRO_EMAIL"
  | "GENERIC"
  | "SPECIAL_EMAIL";

export const PERK_TYPE_PROMO_CODE = PROMO_CODE as PerkType;
export const PERK_TYPE_SPECIAL_URL = SPECIAL_URL as PerkType;
export const PERK_TYPE_INTRO_EMAIL = INTRO_EMAIL as PerkType;
export const PERK_TYPE_GENERIC = GENERIC as PerkType;
export const PERK_TYPE_SPECIAL_EMAIL = SPECIAL_EMAIL as PerkType;

export const PERK_TYPES: readonly PerkType[] = [
  PERK_TYPE_PROMO_CODE,
  PERK_TYPE_SPECIAL_URL,
  PERK_TYPE_INTRO_EMAIL,
  PERK_TYPE_GENERIC,
  PERK_TYPE_SPECIAL_EMAIL,
];

export const PERK_TYPE_OPTIONS = PERK_TYPES.map((perkType) => ({
  label: perkType,
  value: perkType,
}));

export const PERK_STATE_ACTIVE = 0 as const;
export const PERK_STATE_PENDING = 1 as const;

export const PERK_STATE_LABELS: Record<number, string> = {
  [PERK_STATE_ACTIVE]: "Active",
  [PERK_STATE_PENDING]: "Pending",
};

export const PERK_TAB_ALL = "ALL" as const;
export const PERK_TAB_PENDING = "PENDING" as const;
export const PERK_TAB_ACTIVE = "ACTIVE" as const;

export type PerkTab =
  | typeof PERK_TAB_ALL
  | typeof PERK_TAB_PENDING
  | typeof PERK_TAB_ACTIVE;

export const PERK_TAB_TO_STATE: Record<PerkTab, number | null> = {
  [PERK_TAB_ALL]: null,
  [PERK_TAB_PENDING]: PERK_STATE_PENDING,
  [PERK_TAB_ACTIVE]: PERK_STATE_ACTIVE,
};

export const PERKS_PER_PAGE = 20;
